import type { LibrarySketch } from './types';

export const utilitySketches: LibrarySketch[] = [
  {
    id: 'utilities-blend-modes',
    name: 'Blend Modes',
    description: 'Blends two input images using selectable blend modes (multiply, screen, overlay, soft light, etc.).',
    category: 'utilities',
    tags: ['blend', 'composite', 'layers', 'utility', 'image-effect'],
    runtimeMode: 'glsl',
    inputTypes: ['image'],
    params: [
      { name: 'blendMode', type: 'select', default: 'overlay', options: ['multiply', 'screen', 'overlay', 'softlight', 'difference', 'add'], label: 'Blend Mode' },
      { name: 'mixAmount', type: 'float', min: 0.0, max: 1.0, default: 0.5, label: 'Mix' },
      { name: 'tintR', type: 'float', min: 0.0, max: 1.0, default: 0.5, label: 'Tint R' },
      { name: 'tintG', type: 'float', min: 0.0, max: 1.0, default: 0.7, label: 'Tint G' },
      { name: 'tintB', type: 'float', min: 0.0, max: 1.0, default: 1.0, label: 'Tint B' },
    ],
    code: `// @param select blendMode multiply,screen,overlay,softlight,difference,add overlay
// @param float mixAmount 0.0 1.0 0.5
// @param float tintR 0.0 1.0 0.5
// @param float tintG 0.0 1.0 0.7
// @param float tintB 0.0 1.0 1.0

precision mediump float;
uniform sampler2D u_image;
uniform vec2 u_resolution;
uniform float u_time;
uniform float mixAmount;
uniform float tintR;
uniform float tintG;
uniform float tintB;
uniform int blendMode;
varying vec2 v_texCoord;

vec3 blendMultiply(vec3 a, vec3 b) { return a * b; }
vec3 blendScreen(vec3 a, vec3 b) { return 1.0 - (1.0 - a) * (1.0 - b); }
vec3 blendOverlay(vec3 a, vec3 b) {
  return vec3(
    a.r < 0.5 ? 2.0*a.r*b.r : 1.0 - 2.0*(1.0-a.r)*(1.0-b.r),
    a.g < 0.5 ? 2.0*a.g*b.g : 1.0 - 2.0*(1.0-a.g)*(1.0-b.g),
    a.b < 0.5 ? 2.0*a.b*b.b : 1.0 - 2.0*(1.0-a.b)*(1.0-b.b)
  );
}
vec3 blendSoftLight(vec3 a, vec3 b) {
  return (1.0 - 2.0*b)*a*a + 2.0*b*a;
}

void main() {
  vec2 uv = v_texCoord;
  vec3 base = texture2D(u_image, uv).rgb;
  vec3 tint = vec3(tintR, tintG, tintB);
  // Animate tint slightly
  tint += 0.1 * sin(u_time * 0.5 + uv.xyx * 3.0);
  tint = clamp(tint, 0.0, 1.0);
  vec3 result;
  // Mode selection via integer (0=multiply, 1=screen, 2=overlay, 3=softlight, 4=difference, 5=add)
  if (blendMode == 0) result = blendMultiply(base, tint);
  else if (blendMode == 1) result = blendScreen(base, tint);
  else if (blendMode == 2) result = blendOverlay(base, tint);
  else if (blendMode == 3) result = blendSoftLight(base, tint);
  else if (blendMode == 4) result = abs(base - tint);
  else result = clamp(base + tint, 0.0, 1.0);
  vec3 col = mix(base, result, mixAmount);
  gl_FragColor = vec4(col, 1.0);
}`,
  },
];
